"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyStateTitle = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _logging = require("../../logging.js");
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _utils = require("../../utils.js");
var _excluded = ["as", "variant", "semanticColor", "weight"];
var EmptyStateTitleComponent = (0, _styledComponents["default"])(_index2.Text).withConfig({
  displayName: "EmptyStateTitle__EmptyStateTitleComponent",
  componentId: "sc-1x0dyip-0"
})(["padding-block-end:", ";overflow-wrap:break-word;"], (0, _index.cssSpacing)('base', '16px'));

/**
 * EmptyStateTitle is used to suggest an action or convey a benefit.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate-emptystatetitle--docs) |
 * [Encore site](https://encore.spotify.net/web/components/empty-state) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyStateTitle) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=9280-1056&t=uvnU5TzlyKmXuODT-1)
 */
var EmptyStateTitle = exports.EmptyStateTitle = /*#__PURE__*/_react["default"].forwardRef(function EmptyStateTitle(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'h3' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'titleSmall' : _ref$variant,
    _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'textBase' : _ref$semanticColor,
    weight = _ref.weight,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _logging.warnLegacyTypeVariant)('EmptyStateTitle', variant, weight);
  return /*#__PURE__*/_react["default"].createElement(EmptyStateTitleComponent, Object.assign({
    ref: ref,
    forwardedAs: as,
    variant: (0, _utils.mapLegacyToTextVariant)(variant, weight),
    semanticColor: semanticColor,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.EmptyStateTitle
  }, props));
});